//core
import React from 'react';
import { Tooltip, FormControlLabel, Switch, Box } from "@mui/material";
import { SwitchPropsSizeOverrides } from "@mui/material/Switch/Switch";
import { OverridableStringUnion } from "@mui/types";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

//styles
import { useStyles } from './styles'

//types
interface IMuiSwitch {
  name?: string;
  id?: string;
  checked?: boolean;
  label: string;
  size?: OverridableStringUnion<'small' | 'medium', SwitchPropsSizeOverrides>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  sx?: any;
  disabled?: boolean;
  className?: string;
  tooltipText?: string;
}


export const MuiSwitch = (props: IMuiSwitch) => {
  const styles = useStyles();

  const {
    name,
    id,
    checked = false,
    label,
    size = "small",
    onChange,
    sx = {},
    disabled = false,
    className,
    tooltipText = '',
  } = props;

  const labelComponent = !!tooltipText ? (
    <Tooltip title={tooltipText}>
      <Box>
        {label}
        <InfoOutlinedIcon
          className={styles.infoIcon}
          fontSize="small"
          color="action"
        />
      </Box>
    </Tooltip>
  ) : (
    <>{label}</>
  );

  return (
    <>
      <FormControlLabel
        sx={sx}
        className={className}
        control={
          <Switch
            size={size}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            inputProps={{
              id,
              name,
            }}
          />
        }
        label={labelComponent}
      />
    </>
  );
};
